import {
  pullBalanceAmount,
  getCouponsList, getGiftCardsList, getJackeryThingsList, getVirtualCardsList,
  getCustomerCouponsList, getCustomerCouponsThingList, getCustomerGiftcardList, getCustomerVirtualCardsList,
  exchangeRight,
} from "@utils/api.js"

if (!customElements.get('v5-membership-redeem-points')) {
  customElements.define('v5-membership-redeem-points', class V5MembershipRedeemPoints extends HTMLElement {
    constructor() {
      super()
      this.tabDecoResizeObserver = null
      this.redeemResizeObserver = null
      this.apiMap = null
      this.isLoggedIn = false
      this.isExpanded = false
      this.currentList = null
      this.lastIsMobile = null
    }
    connectedCallback() {
      // 编辑模式，阻断
      if (typeof Shopify !== 'undefined' && Shopify.designMode) return

      this.tabsWrap = this.querySelector('.redeem-tabs-wrap')
      this.redeemWrap = this.querySelector('.redeem-points-wrap')

      if (!this.tabsWrap || !this.redeemWrap) return

      this.isLoggedIn = !!window.pageInfo?.customerInfo?.id

      if (this.isLoggedIn && this.querySelector('.subtitle')) {
        // 获取我的积分
        this.getMyPoints()
      }

      const publicApiMap = {
        coupon: getCouponsList,
        gift_card: getGiftCardsList,
        jackery_product: getJackeryThingsList,
        extras: getVirtualCardsList,
      }

      const customerApiMap = {
        coupon: getCustomerCouponsList,
        gift_card: getCustomerGiftcardList,
        jackery_product: getCustomerCouponsThingList,
        extras: getCustomerVirtualCardsList,
      }

      this.apiMap = this.isLoggedIn ? customerApiMap : publicApiMap

      this.initTabEvent()
      this.initTabDecoResizeObserver()
      this.initRedeemResizeObserver()

      const activeTabItem = this.tabsWrap.querySelector('.tab-item.active') || this.tabsWrap.querySelector('.tab-item')
      if (activeTabItem && activeTabItem.dataset.type) {
        this.loadDataForType(activeTabItem.dataset.type)
      }
    }
    disconnectedCallback() {
      if (this.tabDecoResizeObserver) {
        this.tabDecoResizeObserver.disconnect()
        this.tabDecoResizeObserver = null
      }
      if (this.redeemResizeObserver) {
        this.redeemResizeObserver.disconnect()
        this.redeemResizeObserver = null
      }
    }
    // 获取我的积分
    async getMyPoints() {
      const res = await pullBalanceAmount()
      const data = res.data || {}
      const { balancePoint, } = data
      this.balancePoint = balancePoint || 0
      
      // 更新我的积分
      const subtitleSlot = this.querySelector(".v5-redeem-points-slot")
      if (subtitleSlot) {
        subtitleSlot.classList.remove("skeleton")
        subtitleSlot.classList.add("loaded")
        subtitleSlot.textContent = this.balancePoint
      }
    }
    // 初始化 tab 事件
    initTabEvent() {
      this.tabsWrap.querySelectorAll('.tab-item').forEach((tabItem) => {
        tabItem.addEventListener('click', () => {
          if (tabItem.classList.contains('active')) return

          // 移除旧的 active 类
          const lastActive = this.tabsWrap.querySelector('.tab-item.active')
          if (lastActive) {
            lastActive.classList.remove('active')
          }
          tabItem.classList.add('active')

          // 横向平滑地滚动内容
          scrollContentXSmoothly(tabItem, this.tabsWrap)

          // 更新 tab 下划线位置
          this.updateTabDecoLinePosition()

          const { type } = tabItem.dataset
          if (type) {
            this.loadDataForType(type)
          }
        })
      })
    }
    initTabDecoResizeObserver() {
      if (!window.ResizeObserver) return

      if (!this.tabsWrap) return

      if (this.tabDecoResizeObserver) {
        this.tabDecoResizeObserver.disconnect()
      }

      this.tabDecoResizeObserver = new ResizeObserver(() => {
        this.updateTabDecoLinePosition()
      })

      this.tabDecoResizeObserver.observe(this.tabsWrap)
    }
    initRedeemResizeObserver() {
      if (!window.ResizeObserver) return

      if (!this.redeemWrap) return

      if (this.redeemResizeObserver) {
        this.redeemResizeObserver.disconnect()
      }

      this.redeemResizeObserver = new ResizeObserver(() => {
        if (!this.currentList || this.isExpanded) return
        const isMobile = window.innerWidth < 1024
        if (typeof this.lastIsMobile === 'boolean' && isMobile === this.lastIsMobile) return
        this.lastIsMobile = isMobile
        this.renderRedeemList(this.currentList)
      })

      this.redeemResizeObserver.observe(this)
    }
    async loadDataForType(type) {
      if (!type || !this.apiMap || !this.redeemWrap) return

      this.isExpanded = false
      this.currentList = null

      const apiMethod = this.apiMap[type]
      if (!apiMethod) {
        this.renderRedeemList([])
        return
      }

      this.redeemWrap.innerHTML = this.renderSkeleton()

      try {
        const res = await apiMethod()
        const list = res?.data?.rights || []
        this.currentList = list
        this.renderRedeemList(list)
      } catch (e) {
        console.error(e)
        this.renderRedeemList([])
      }
    }
    // 更新 tab 下划线位置
    updateTabDecoLinePosition() {
      const activeTabItem = this.tabsWrap.querySelector('.tab-item.active')
      if (activeTabItem) {
        const tabDecoLine = this.tabsWrap.querySelector('.tab-deco-line')
        if (tabDecoLine) {
          tabDecoLine.style.left = `${activeTabItem.offsetLeft}px`
          tabDecoLine.style.width = `${activeTabItem.offsetWidth}px`
        }
      }
    }
    // 骨架屏
    renderSkeleton() {
      const isMobile = window.innerWidth < 1024
      this.lastIsMobile = isMobile
      const limit = isMobile ? 4 : 8
      return Array.from({ length: limit }).map(() => `
        <li class="bg-white flex flex-col w-full h-[17.125rem] gap-y-2 lg:h-[20.5rem] p-4">
          <div class="flex-shrink-0 w-full h-[8.1875rem] lg:h-[12.75rem] skeleton"></div>
          <div class="w-3/5 h-6 lg:h-9 skeleton"></div>
          <div class="flex flex-col gap-y-4 lg:flex-row lg:items-center lg:justify-between lg:mt-2">
            <span class="inline-flex w-9 h-5 skeleton"></span>
            <span class="inline-flex w-24 h-[1.875rem] lg:w-40 lg:h-8 skeleton"></span>
          </div>
        </li>
      `).join('')
    }
    renderRedeemList(list) {
      if (!Array.isArray(list) || list.length === 0) {
        // 渲染无数据
        const noDataText = this.redeemWrap.dataset.noDataText || ''
        this.redeemWrap.innerHTML = `
          <div class="w-full text-center font-semibold text-black text-xl col-span-2 lg:col-span-4 lg:text-[1.75rem] lg:leading-[2.25rem] pt-5">
            ${noDataText.replace(/\n/g, '<br>')}
          </div>
        `
        return
      }

      const isMobile = window.innerWidth < 1024
      const limit = isMobile ? 4 : 8
      const showAll = this.isExpanded === true
      const renderList = showAll ? list : list.slice(0, limit)

      const itemsHtml = renderList.map((item, index) => (`
        <li class="bg-white flex flex-col w-full ${item.goodsTitle ? 'h-[21.25rem] lg:h-[26.5rem]' : 'h-[17.125rem] lg:h-[20.5rem]'} gap-y-2 p-4">
          ${!item.history && item.imageType !== 1
            ? `<img class="flex-shrink-0 w-full h-[8.1875rem] lg:h-[12.75rem] object-contain" src="${item.image}" alt="" loading="lazy">`
            : `
                <div class="flex-shrink-0 w-full h-[8.1875rem] lg:h-[12.75rem]">
                  <div
                    class="w-full h-full flex items-center justify-center color-white font-semibold relative ${item.imageType === 1 ? '!w-[90%]' : ''}"
                    style="${item.imageType === 1
                      ? `background:url(${item.image}) center center /contain no-repeat;`
                      : `background:url('https://cdn.shopifycdn.net/s/files/1/0550/0524/9633/files/ead6f1d359da789814cd78421b6956bb.png?v=1686109159') center center /contain no-repeat`
                    }"
                  >
                    ${item.imageType !== 1 ? `<div class="absolute right-2.5 top-3 lg:top-0 text-sm lg:text-base font-semibold">${item.off}</div>` : ''}
                    <div class="font-semibold text-white text-3xl lg:text-5xl" style="${item.imageType === 1 ? 'white-space:nowrap;' : ''}">
                      ${item.rightValue}
                      ${item.imageType === 1 ? `<span class="text-xs lg:text-sm -lg:ml-1">${item.off}</span>` : ''}
                    </div>
                  </div>
                </div>
              `
          }
          <div class="flex-1 flex flex-col justify-between gap-y-4">
            ${item.goodsTitle
              ? `
                  <div class="flex flex-col gap-y-2">
                    <h2 class="font-semibold text-[#242F20] text-xs lg:text-base line-clamp-2 h-8 lg:h-12" title="${item.goodsTitle}">${item.goodsTitle}</h2>
                    <p class="font-semibold text-[#242F20] text-xs lg:text-base">
                      ${item.currencyTypePrefix === '€' ? `${item.goodsPrice}${item.currencyTypePrefix}` : `${item.currencyTypePrefix}${item.goodsPrice}`}
                    </p>
                  </div>
                `
              : ''
            }
            <div class="flex flex-col gap-y-2">
              ${item.pointValue
                ? `
                    <div class="flex flex-col gap-y-4 lg:flex-row lg:items-center lg:justify-between">
                      <span class="inline-flex font-semibold text-[#242F20] text-base lg:text-[1.75rem] lg:leading-[2.25rem]">
                        ${item.pointValue} Points
                      </span>
                    </div>
                  `
                : ''
              }
              <div class="flex flex-col items-start gap-y-4 lg:flex-row lg:items-center lg:justify-between lg:mt-2">
                <button
                  class="appearance-none bg-transparent text-black/65 text-sm underline underline-offset-4"
                  data-rules-btn
                  data-index="${index}"
                >${this.redeemWrap.dataset.rulesText}</button>
                ${!item.outStockFlag
                  ? !this.isLoggedIn || (this.isLoggedIn && item.pointEnough)
                    ? `
                        <button
                          class="appearance-none bg-transparent font-semibold text-primary text-[0.75rem] h-[1.875rem] lg:h-8 lg:text-[1.25rem] lg:leading-[2rem]"
                          data-redeem-btn
                          data-index="${index}"
                        >
                          ${this.redeemWrap.dataset.redeemNowText}
                          <svg class="text-primary w-3 h-3 lg:w-4 lg:h-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_4559_7516)">
                              <path d="M-1 9.25H11.2422" stroke="currentColor" stroke-width="1.6"/>
                              <path d="M8.49219 3L14.7419 9.24976L8.49219 15.4995" stroke="currentColor" stroke-width="1.6"/>
                            </g>
                            <defs>
                              <clipPath id="clip0_4559_7516"><rect width="16" height="16" fill="white"/></clipPath>
                            </defs>
                          </svg>
                        </button>
                      `
                    : `<span class="font-semibold text-black/30 text-[0.75rem] h-[1.875rem] leading-[1.875rem] lg:h-8 lg:text-[1.25rem] lg:leading-[2rem]">
                        ${this.redeemWrap.dataset.redeemNowText}
                        <svg class="text-black/30 w-3 h-3 lg:w-4 lg:h-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_4559_7516)">
                            <path d="M-1 9.25H11.2422" stroke="currentColor" stroke-width="1.6"/>
                            <path d="M8.49219 3L14.7419 9.24976L8.49219 15.4995" stroke="currentColor" stroke-width="1.6"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_4559_7516"><rect width="16" height="16" fill="white"/></clipPath>
                          </defs>
                        </svg>
                      </span>`
                  : `<span class="font-semibold text-black/30 text-[0.75rem] h-[1.875rem] leading-[1.875rem] lg:h-8 lg:text-[1.25rem] lg:leading-[2rem]">${this.redeemWrap.dataset.outOfStockText}</span>`
                }
              </div>
            </div>
          </div>
        </li>
      `)).join('')

      let viewMoreHtml = ''
      if (!showAll && list.length > limit) {
        viewMoreHtml = `
          <li class="w-full flex items-center justify-center col-span-2 lg:col-span-4">
            <button
              class="appearance-none bg-transparent font-semibold text-[#242F20] text-sm lg:text-base underline underline-offset-4"
              data-view-more-btn
            >${this.redeemWrap.dataset.viewMoreText || 'View More'}</button>
          </li>
        `
      }

      this.redeemWrap.innerHTML = itemsHtml + viewMoreHtml

      this.registerBtnEvent(renderList)
      this.initViewMoreEvent(list)
    }
    initViewMoreEvent(fullList) {
      const btn = this.redeemWrap.querySelector('[data-view-more-btn]')
      if (!btn) return

      btn.addEventListener('click', () => {
        this.isExpanded = true
        this.renderRedeemList(fullList)
      })
    }
    registerBtnEvent(data) {
      // Rules 规则按钮
      this.redeemWrap.querySelectorAll('[data-rules-btn]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          const { index } = e.target.dataset
          this.showRulesAndRedeemModal('rule', data[index])
        })
      })

      // Redeem Now 兑换按钮
      this.redeemWrap.querySelectorAll('[data-redeem-btn]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          // 已登录
          if (this.isLoggedIn) {
            const { index } = e.target.dataset
            this.showRulesAndRedeemModal('redeem', data[index])
          }
          // 未登录
          else {
            if(window.jackeryLoginApp) {
              window.jackeryLoginApp.modalLogin({
                return_url: window.location.href,
                register_act: 'MEM-Register,JFDH-Register'
              })
            }
          }
        })
      })
    }
    // 复制
    handleCopy(discountCode, goodsDetailUrl, btn) {
      copyString(discountCode, () => {
        // 提示 copy 成功
        pushSuccessMessage(this.redeemWrap.dataset.copySuccessText)

        // 产品 跳产品下单页，优惠券/礼品卡 跳转官网 Collection 页面
        // 聚合页链接
        const COLLECTION_LINK = {
          US: '/',
          CA: '/pages/solar-generator',
          GB: '/',
          DE: '/',
          FR: '/',
          IT: '/',
          ES: '/',
          JP: '/collections/all?sort_by=created-descending',
          AU: '/',
          EU: '/',
        }
        const url = goodsDetailUrl || `${COLLECTION_LINK[window.pageInfo?.cr || 'US']}`
        setTimeout(() => {
          btn?.removeAttribute?.('loading')
          window.location.href = url
        }, 1000)
      })
    }
    // 显示 规则、兑换弹窗
    showRulesAndRedeemModal(type, target) {
      const dialog = this.querySelector(`.v5-membership-rules-redeem-dialog`)
      dialog.querySelector('[data-content]').innerHTML = this.renderRulesAndRedeemModal(type, target)
      dialog.setAttribute('open', true)

      dialog.querySelectorAll('[data-type]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const { type, } = btn.dataset
          btn.setAttribute('loading', true)
          if (type === 'redeem') {
            btn.removeAttribute('loading')
            
            this.showConfirmModal({ parentDialog: dialog, target })
          }
          else if (type === 'copy') {
            this.handleCopy(this.redeemedObj.discountCode, this.redeemedObj.goodsDetailUrl, btn)
          } else {
            btn.removeAttribute('loading')
            dialog.removeAttribute('open')
          }
        })
      })
    }
    // 规则、兑换弹窗 DOM
    renderRulesAndRedeemModal(type, item) {
      return `
        ${!item.history && item.imageType !== 1
          ? `<img class="w-full h-[8.1875rem] lg:h-[12.75rem]" src="${item.image}" alt="" width="392" height="204" loading="lazy">`
          : `
              <div class="w-full h-[8.1875rem] lg:h-[12.75rem]">
                <div
                  class="w-full h-full flex items-center justify-center color-white font-semibold relative ${item.imageType === 1 ? '!w-[90%]' : ''}"
                  style="${item.imageType === 1
                    ? `background:url(${item.image}) center center /contain no-repeat;`
                    : `background:url('https://cdn.shopifycdn.net/s/files/1/0550/0524/9633/files/ead6f1d359da789814cd78421b6956bb.png?v=1686109159') center center /contain no-repeat`
                  }"
                >
                  ${item.imageType !== 1 ? `<div class="absolute right-2.5 top-3 lg:top-0 text-sm lg:text-base font-semibold">${item.off}</div>` : ''}
                  <div class="font-semibold text-white text-3xl lg:text-5xl" style="${item.imageType === 1 ? 'white-space:nowrap;' : ''}">
                    ${item.rightValue}
                    ${item.imageType === 1 ? `<span class="text-xs lg:text-sm -lg:ml-1">${item.off}</span>` : ''}
                  </div>
                </div>
              </div>
            `
        }
        ${item.pointValue
          ? `<h3 class="w-full text-center font-semibold text-[#242F20] text-xl lg:text-[1.75rem]" data-points>${item.pointValue} ${this.redeemWrap.dataset.pointsText}</h3>`
          : item.discountCode
            ? `<h3 class="w-full text-center font-semibold text-[#242F20] text-xl lg:text-[1.75rem]">${this.redeemWrap.dataset.codeText}: ${item.discountCode}</h3>`
            : ''
        }
        
        ${item.goodsTitle || item.goodsPrice
          ? `
            <div class="flex flex-col gap-y-2">
              ${item.goodsTitle ? `<p class="font-semibold text-[#242F20] text-xs lg:text-base">${item.goodsTitle}</p>` : ''}
              <p class="font-semibold text-[#242F20] text-xs lg:text-base">
                ${item.currencyTypePrefix === '€' ? `${item.goodsPrice}${item.currencyTypePrefix}` : `${item.currencyTypePrefix}${item.goodsPrice}`}
              </p>
            </div>
          `
          : ''
        }
        <div class="flex flex-col gap-y-3 pt-5 border-0 border-t-[1px] border-solid border-[#C6C7C8]">
          <h4 class="font-semibold text-[#242F20] text-xs lg:text-base">${this.redeemWrap.dataset.rulesText}</h4>
          <div class="w-full font-normal text-[#242F20] text-xs lg:text-sm" data-rules>${item.ruleInfo}</div>
        </div>
        ${type === 'redeem'
          ? `
            <div class="w-full flex items-center justify-center gap-6 pb-[1px]">
              <jds-button data-type="cancel" variant="secondary" kind="custom" style="--jds-btn-custom-color:#242F20;">${this.redeemWrap.dataset.cancelRedeemText}</jds-button>
              <jds-button data-type="redeem" kind="custom" style="--jds-btn-custom-color:#242F20">${this.redeemWrap.dataset.redeemText}</jds-button>
              <jds-button data-type="copy" class="hidden" kind="custom" style="--jds-btn-custom-color:#242F20">${this.redeemWrap.dataset.copyAndUseText}</jds-button>
            </div>
          `
          : ''
        }
      `
    }
    // 二次确认弹窗
    showConfirmModal({ parentDialog, target }) {
      const dialog = this.querySelector(`.v5-membership-redeem-confirm-dialog`)
      const contentDom = dialog.querySelector('[data-content]')
      contentDom.innerHTML = contentDom.dataset.content.replace('{0}', target.pointValue).replace(/\n/g, '<br>')
      dialog.setAttribute('open', true)

      const buttons = dialog.querySelectorAll('[data-type]')
      buttons.forEach((btn) => {
        const cloned = btn.cloneNode(true)
        btn.parentNode.replaceChild(cloned, btn)
      })

      dialog.querySelectorAll('[data-type]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          if (btn.hasAttribute('loading')) {
            return
          }
          const { type, redeemSuccessText } = btn.dataset
          btn.setAttribute('loading', true)
          if (type === 'redeem') {
            try {
              const res = await exchangeRight({ ruleId: target.ruleId, version: target.version })
              if (res.code === 200) {
                const { balancePoint, discountCode, ruleInfo, goodsDetailUrl, } = res.data || {}

                if (balancePoint === null || balancePoint === undefined) return

                this.balancePoint = balancePoint || 0

                const subtitleSlot = this.querySelector(".v5-redeem-points-slot")
                if (subtitleSlot) {
                  subtitleSlot.classList.remove("skeleton")
                  subtitleSlot.classList.add("loaded")
                  subtitleSlot.textContent = this.balancePoint
                }

                this.redeemedObj = { balancePoint, discountCode, ruleInfo, goodsDetailUrl }

                const pointsDom = parentDialog.querySelector('[data-points]')
                if (pointsDom) {
                  pointsDom.innerHTML = `${this.redeemWrap.dataset.codeText}: ${discountCode}`
                }

                // 提示语
                pushSuccessMessage(redeemSuccessText)

                const myPointsDOM = document.querySelector('v5-membership-my-points')
                if (myPointsDOM) {
                  const balancePointWrap = myPointsDOM.querySelector('.balance-point-wrap')
                  if (balancePointWrap) {
                    balancePointWrap.innerHTML = `<span class="font-semibold text-[#242F20] text-5xl">${balancePoint}</span>`
                  }

                  const rewardsSubtitle = myPointsDOM.querySelector('[data-rewards-subtitle]')
                  if (rewardsSubtitle) {
                    const subtitleSpan = rewardsSubtitle.querySelector('span')
                    if (subtitleSpan) {
                      subtitleSpan.innerHTML = balancePoint
                    }
                  }
                }

                const rulesDom = parentDialog.querySelector('[data-rules]')
                if (rulesDom) {
                  rulesDom.innerHTML = ruleInfo
                }

                const redeemBtn = parentDialog.querySelector('[data-type="redeem"]')
                const copyBtn = parentDialog.querySelector('[data-type="copy"]')
                if (redeemBtn && copyBtn) {
                  redeemBtn.classList.add('hidden')
                  copyBtn.classList.remove('hidden')
                }
              } else {
                pushErrorMessage(res.message || 'Redeem Failed!')
              }
            } catch (err) {
              pushErrorMessage(err.message || 'Redeem Failed!')
            } finally {
              btn.removeAttribute('loading')
              dialog.removeAttribute('open')
            }
          } else {
            btn.removeAttribute('loading')
            dialog.removeAttribute('open')
          }
        })
      })
    }
  })
}
